// This file is auto-generated by dibs-icons script
import { type FC } from 'react';

type ImageSearch24Props = {
    dataTn?: string;
    role?: 'img';
    ariaLabel?: string;
    ariaLabelledby?: string;
};

const ImageSearch24: FC<ImageSearch24Props> = props => {
    return (
        <svg
            style={{ display: 'block' }}
            data-tn={props.dataTn}
            role={props.role}
            aria-label={props.ariaLabel}
            aria-labelledby={props.ariaLabelledby}
            width="24"
            height="24"
            viewBox="0 0 24 24"
        >
            <path d="M19.5 12.2a1 1 0 1 1 2 0v5a3 3 0 0 1-3 3h-14a3 3 0 0 1-3-3v-10a3 3 0 0 1 3-3h9a1 1 0 1 1 0 2h-9a1 1 0 0 0-1 1v10a1 1 0 0 0 1 1h14a1 1 0 0 0 1-1z" />
            <path d="M13.5 12.2a2 2 0 1 0-2 2v2a4 4 0 1 1 0-8 4 4 0 0 1 0 8v-2a2 2 0 0 0 2-2M16.07 6.39a.2.2 0 0 1 0-.38l.532-.177a4 4 0 0 0 2.53-2.53l.178-.533a.2.2 0 0 1 .38 0l.177.533a4 4 0 0 0 2.53 2.53l.534.178a.2.2 0 0 1 0 .38l-.534.177a4 4 0 0 0-2.53 2.53l-.177.533a.2.2 0 0 1-.38 0l-.178-.533a4 4 0 0 0-2.53-2.53z" />
        </svg>
    );
};

export default ImageSearch24;
